(function videoScript($, Drupal) {
  Drupal.behaviors.video = {
    attach(context) {
      context = context || document;

      var video = $('.video');
      doEmbeddedVideoCookieConsent();
      window.addEventListener('CookiebotOnAccept', doEmbeddedVideoCookieConsent);
      window.addEventListener('CookiebotOnDecline', doEmbeddedVideoCookieConsent);

      var videoItem = $(".video__item");
      var videoTrigger = $(".video__placeholder-play");

      if (!videoItem.length) {
        return;
      }

      if (!videoTrigger.length) {
        return;
      }

      var videoPlayer = $(videoItem).find('iframe');

      $(videoTrigger).click(function(e){
        e.preventDefault();
        var currentVideoPlayer =  $(this).closest('.video').find(videoPlayer);
        $(this).parent('.video__placeholder').toggle();
        $(this).parent('.video__placeholder').next(videoItem).toggleClass('active');
        $(currentVideoPlayer).attr("src", $(currentVideoPlayer).attr("src").replace("autoplay=0", "autoplay=1"));
      });

      function doEmbeddedVideoCookieConsent() {
        $(video).each(function () {

          if ($(this).find('img.placeholder').length) {
            var placeholder = $(this).find('img.placeholder').attr('src');
            if ($(this).find('.video-embed-field-lazy img.image-style-crop-thumbnail').length) {
              $(this).find('.video-embed-field-lazy img.image-style-crop-thumbnail').attr('src', placeholder);
            }
          }

          var marketingconsent = getCookieForEmbeddedVideos('cookiebot-consent--marketing');

          if (parseInt(marketingconsent) === 1) {
            if ($(this).find('.fingal-cookiebotconsent-video-optout').length) {
              $(this).find('.fingal-cookiebotconsent-video-optout').remove();
            }
            $(this).find('.video-embed-field-lazy').click(function(e) {
              // Swap the lightweight image for the heavy JavaScript.
              e.preventDefault();
              var $el = $(this);
              $el.html($el.data('video-embed-field-lazy'));
              if (typeof window.Cookiebot !== "undefined") {
                setTimeout(() => {
                  window.Cookiebot.runScripts();
                }, 0);
              }
            });
          } else if (parseInt(marketingconsent) === 0) {
            $(this).find('div[data-video-embed-field-lazy]').append('<div class="anrt-cookiebotconsent-optout fingal-cookiebotconsent-video-optout"><a href="javascript:Cookiebot.renew()">The video provider requires that you accept marketing and statistics cookies in order to view this video.</a></div>').off('click');
          }
          $(this).css('visibility', 'visible');
        });
      }

      function getCookieForEmbeddedVideos(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }

    },
  };
}(jQuery, Drupal));
